<nav
  *ngIf="content.indexes.length > 0"
  [attr.aria-label]="content.ariaLabels.title"
  role="navigation"
>
  <ul class="paginator">
    <li
      [ngClass]="[
        content.first !== content.activePage
          ? 'paginator__item--show'
          : 'paginator__item--hide'
      ]"
      class="paginator__item paginator__item--prev"
    >
      <a
        (click)="
          setPage(content.activePage - 1);
          setAriaLabel(
            $event,
            content.ariaLabels.current + ' ' + (content.activePage - 1)
          )
        "
        (focus)="setAriaLabel($event, content.ariaLabels.previous)"
        class="paginator__link"
        href="#"
        onclick="return false;"
      >
        {{ content.previous }}
      </a>
    </li>
    <li
      *ngFor="let index of content.indexes; index as i"
      class="paginator__item"
    >
      <a
        (click)="setPage(index)"
        [attr.aria-current]="index === content.activePage"
        [attr.aria-label]="
          (index === content.activePage ? content.ariaLabels.current : 'Page') +
          ' ' +
          index
        "
        [ngClass]="{ active: index === content.activePage }"
        class="paginator__link"
        href="#"
        onclick="return false;"
      >
        {{ index }}
      </a>
    </li>
    <li
      [ngClass]="[
        content.last !== content.activePage
          ? 'paginator__item--show'
          : 'paginator__item--hide'
      ]"
      class="paginator__item paginator__item--next"
    >
      <a
        (click)="
          setPage(content.activePage + 1);
          setAriaLabel(
            $event,
            content.ariaLabels.current + ' ' + (content.activePage + 1)
          )
        "
        (focus)="setAriaLabel($event, content.ariaLabels.next)"
        class="paginator__link"
        href="#"
        onclick="return false;"
      >
        {{ content.next }}
      </a>
    </li>
  </ul>
</nav>
